import React from 'react';
import { Select } from 'antd';
import AuthLogic from '../AuthLogic/index.js';

const { Option } = Select;

const ContextMenu = ({ menuTitle, user, menuArray, handleSelection }) => {

      return (
      <Select  value={menuTitle}  style={{ width: 200 }}
      >
        {
          menuArray.map((elem, i) => {
            return (
              elem.authRule &&
              AuthLogic[`${elem.authRule}`] &&
              AuthLogic[`${elem.authRule}`](user) // returns true if user has requisite security value
              &&

              <Option
                key={elem.name}
                onClick={(key) => handleSelection(key)}
              >
                {elem.name}
              </Option>
            );
          })
        }
    </Select>
      );

  }

export default ContextMenu;

